import React from 'react';
import { Route } from 'react-router-dom';
import LazyRoute from 'lazy-route';

const groupRoutes = [
  <Route
    key="grouplist"
    exact
    path="/grouplist"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/GroupLists")}
      />
    )}
  />,
  <Route
    key="grouplist-pid"
    exact
    path="/grouplist/:pid"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/Groups")}
      />
    )}
  />,
  <Route
    key="posts"
    exact
    path="/posts/:type/:pid"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/Wall")}
      />
    )}
  />,
  <Route
    key="posts-gid"
    exact
    path="/posts/:type/:pid/:gid"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/Wall")}
      />
    )}
  />,
  <Route
    key="chat"
    exact
    path="/chat/:pid/:gid/:packid"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/GroupChat")}
      />
    )}
  />,
  <Route
    key="live"
    exact
    path="/live/:pid/:gid/:packid"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/GroupChatZoom")}
      />
    )}
  />,
  <Route
    key="preview-package"
    exact
    path="/preview_package/:pid/:gid/:packid"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/StudentProfileSinglePackageSpecific")}
      />
    )}
  />
];

export default groupRoutes; 